<template>
  <v-dialog
    v-model="show"
    persistent
    :max-width="options.width"
  >
    <v-card>
      <v-toolbar
        v-if="!!title"
        :color="options.titleColor"
        dark
        dense
        flat
      >
        <v-toolbar-title class="white--text">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title
        v-show="!!options.headingMessage"
      ></v-card-title>
      <v-card-text
        v-show="!!options.headingMessage"
      >
        <h2 style="white-space:pre-wrap; word-wrap:break-word;">
          {{ options.headingMessage }}
        </h2>
      </v-card-text>
      <v-card-text
        v-show="!!message"
        class="pa-4 text-center"
        style="white-space:pre-wrap; word-wrap:break-word;"
      >
        {{ message }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
          v-if="options.isCancelButton"
          :color="options.cancelButtonColor"
          text
          @click="onCancel"
        >
          {{ options.cancelTitle }}
        </v-btn>
        <v-spacer />
        <v-btn
          :color="options.successButtonColor"
          text
          @click="onSuccess"
        >
          {{ options.successTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  /**
   * example
   * <Confirm ref="confirm" />
   * methods: {
   *   showDialog () {
   *     // open
   *     this.$refs.confirm.open({title: 'title', message: 'message', options: null}).then((confirm) => {
   *       // confirm true: ok false: cancel
   *       this.$refs.confirm.close()
   *     })
   *     // delete dialog
   *     this.$refs.confirm.showDeleteConfirm().then((confirm) => {
   *       // confirm true: ok false: cancel
   *       this.$refs.confirm.close()
   *     })
   *   }
   * }
   */
  export default {
    name: 'ConfirmComponent',
    data () {
      return {
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
        options: {
          titleColor: 'primary',
          width: 290,
          headingMessage: null,
          isCancelButton: true,
          successTitle: 'OK',
          successButtonColor: 'primary',
          cancelTitle: 'Cancel',
          cancelButtonColor: 'grey',
        }
      }
    },
    computed: {
      show: {
        get() {
          return this.dialog
        },
        set(value) {
          this.dialog = value
          if (value === false) {
            this.cancel()
          }
        }
      },
    },
    methods: {
      open ({title, message, options}) {
        // 前回開いた際のoptionsを引き継いでしまうので初期化
        Object.assign(this.$data.options, this.$options.data().options)

        this.title = title
        this.message = message
        this.options = Object.assign(this.options, options)
        this.dialog = true

        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      close () {
        this.dialog = false
      },
      showDeleteConfirm () {
        return this.open({ title: '削除', message: '削除してよろしいですか？', options: { titleColor: 'red' } })
      },
      showDuplicateConfirm () {
        return this.open({ title: '複写', message: '複写してよろしいですか？', options: { titleColor: 'blue' } })
      },
      showCancelPricePlanConfirm () {
        return this.open({ title: '　', message: '対象の排出事業者は２年以内にマニフェスト作成されているかまたはテナントで全削除されていませんがJWNET料金プランを解約で登録してもよろしいですか？', options: { titleColor: 'red', width: 700 } })
      },


      onSuccess () {
        this.resolve(true)
        this.close()
      },
      onCancel () {
        this.resolve(false)
        this.close()
      },
    }
  }

</script>

<style scoped lang="scss">
</style>